import { EXPRESS_API } from 'configs/api/expressApi';
import { useMutation, useQueryClient } from 'react-query';
import { OrganizationVideo } from './useOrganizationVideoQuery';
import { organizationVideoQueryKeys } from './queryKeys';

const createOrganizationVideo = async (body: Partial<OrganizationVideo>) => {
  return await EXPRESS_API.post(`/organization-videos/create`, body);
};

export const useCreateOrganizationVideoMutation = () => {
  const queryClient = useQueryClient();
  return useMutation(
    (body: Partial<OrganizationVideo>) => createOrganizationVideo(body),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(organizationVideoQueryKeys.all);
      },
    }
  );
};
